import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import ThemeToggle from './ThemeToggle';

const NAV_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/contact', label: 'Contact Us' },
  { to: '/login', label: 'Sign In' },
  { to: '/register', label: 'Create Account' }
];

// Same header band pattern as the logged-in Layout.js Navbar (border-bottom, body-tertiary,
// data-bs-theme), so public and authenticated pages read as one product instead of two.
function PublicHeader() {
  const { pathname } = useLocation();
  const { theme } = useTheme();

  return (
    <Navbar expand="md" className="border-bottom" data-bs-theme={theme} bg="body-tertiary">
      <Container>
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
          <img
            src="https://s3.amazonaws.com/public.ibigdo.com/c/img/logo_ibigdo.png"
            alt="iBigDo"
            style={{ height: '34px', objectFit: 'contain' }}
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="public-nav" />
        <Navbar.Collapse id="public-nav">
          <Nav className="ms-auto align-items-md-center">
            {NAV_LINKS.map((link) => (
              <Nav.Link key={link.to} as={Link} to={link.to} active={pathname === link.to}>
                {link.label}
              </Nav.Link>
            ))}
            <ThemeToggle />
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default PublicHeader;
